import types from './types';

const INITIAL_STATE = {
  isCheckingBenefit: false,
  isCheckingCode: false,

  result: [],
};

const authMediCalReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_REQUEST:
        return {
            ...state,
            result: [],
            isCheckingBenefit: true,
        };

    case types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isCheckingBenefit: false,
        };

    case types.CHECK_MEDI_CAL_BENEFIT_RESTRICT_FAILURE:
        return {
            ...state,
            result: [],
            isCheckingBenefit: false,
        };

    case types.CHECK_MEDI_CAL_CODE_REQUEST:
        return {
            ...state,
            result: [],
            isCheckingCode: true,
        };

    case types.CHECK_MEDI_CAL_CODE_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isCheckingCode: false,
        };

    case types.CHECK_MEDI_CAL_CODE_FAILURE:
        return {
            ...state,
            result: [],
            isCheckingCode: false,
        };

    default:
      return state;
  }
};

export default authMediCalReducer;
